import EntityType from '@/models/Shared/EntityType';

export default class CreateConversationParticipantRequest {
    entityId = '';
    entityType: EntityType;
}